import { autoinject, bindable, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import * as CD from 'app/cd/models/essette-api';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class HouseholdsPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable({ defaultBindingMode: bindingMode.twoWay })
    protected createHouseholdOpen: boolean = false;

    @bindable({ defaultBindingMode: bindingMode.twoWay })
    protected household: CD.Household = {};

    protected id: guid = guid();

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////

}
